/*
 * ==========================================================================
 * CUSTOM HEADER SCRIPT (FINAL + MOBILE SLIDING PANELS)
 * ==========================================================================
*/

(function() {
  const selectors = {
    body: 'body',
    header: '#site-header',
    megaMenuItem: '.nav-item.has-megamenu', // Selector for the mega menu list item
    timepieceMenu: '[data-megamenu-type="timepiece"]',
    sidebarLink: '.megamenu-sidebar li',
    contentPane: '.megamenu-content .megamenu-pane',
    mobileTrigger: '#mobile-menu-trigger',
    mobilePanel: '#mobile-menu-panel',
    mobileClose: '#mobile-menu-close',
    mobileOverlay: '#mobile-menu-overlay',
    // New selectors for sliding menu
    mobileMenuInner: '.mobile-menu__inner',
    submenuTrigger: '.has-submenu > .mobile-nav__link',
    submenuPanel: '.mobile-submenu-panel',
    submenuBack: '.mobile-submenu__back'
  };

  const classes = {
    sticky: 'is-sticky',
    active: 'active',
    megaMenuActive: 'has-megamenu-active', // Class for the active mega menu list item
    mobileMenuOpen: 'mobile-menu-is-open',
    submenuOpen: 'is-open'
  };

  class CustomHeader {
    constructor(container) {
      this.container = container;
      this.header = this.container.querySelector(selectors.header);

      if (!this.header) {
        return;
      }

      this.initDesktopFeatures();
      this.initMobileFeatures();
    }

    // --- DESKTOP LOGIC ---
    initDesktopFeatures() {
      if (this.isStickyInitialized) return;

      // Sticky Header Logic
      this.handleScroll = () => {
        const isStuck = window.scrollY > 300; // Increased threshold
        this.header.classList.toggle(classes.sticky, isStuck);
      };
      window.addEventListener('scroll', this.handleScroll, { passive: true });
      this.isStickyInitialized = true;

      // --- START: NEW LOGIC FOR MEGAMENU ACTIVE CLASS ---
      const megaMenuItems = this.header.querySelectorAll(selectors.megaMenuItem);
      megaMenuItems.forEach(item => {
        item.addEventListener('mouseenter', () => {
          item.classList.add(classes.megaMenuActive);
        });
        item.addEventListener('mouseleave', () => {
          item.classList.remove(classes.megaMenuActive);
        });
      });
      // --- END: NEW LOGIC ---

      // Interactivity within the mega menu panels
      const timepieceMenus = this.header.querySelectorAll(selectors.timepieceMenu);
      timepieceMenus.forEach(this.initMegaMenuInteractivity.bind(this));
    }

    initMegaMenuInteractivity(menu) {
      const sidebarLinks = menu.querySelectorAll(selectors.sidebarLink);
      const contentPanes = menu.querySelectorAll(selectors.contentPane);

      if (sidebarLinks.length > 0) {
        sidebarLinks[0].classList.add(classes.active);
      }

      sidebarLinks.forEach(link => {
        link.addEventListener('mouseenter', () => {
          const menuHandle = link.dataset.menuHandle;
          sidebarLinks.forEach(l => l.classList.remove(classes.active));
          link.classList.add(classes.active);
          contentPanes.forEach(pane => pane.style.display = 'none');
          const activePane = menu.querySelector(`.megamenu-pane[data-pane-handle="${menuHandle}"]`);
          if (activePane) activePane.style.display = 'block';
        });
      });
    }

    // --- MOBILE LOGIC ---
    initMobileFeatures() {
      const trigger = this.container.querySelector(selectors.mobileTrigger);
      const panel = this.container.querySelector(selectors.mobilePanel);
      const close = this.container.querySelector(selectors.mobileClose);
      const overlay = this.container.querySelector(selectors.mobileOverlay);

      if (!trigger || !panel) return;

      trigger.addEventListener('click', () => {
        document.body.classList.add(classes.mobileMenuOpen);
      });

      const closeMenu = () => {
        document.body.classList.remove(classes.mobileMenuOpen);
        // also close all submenus
        panel.querySelectorAll(selectors.submenuPanel).forEach(p => p.classList.remove(classes.submenuOpen));
      };

      close.addEventListener('click', closeMenu);
      overlay.addEventListener('click', closeMenu);

      this.initMobileSlideNavigation(panel);
    }

    initMobileSlideNavigation(panel) {
      const triggers = panel.querySelectorAll(selectors.submenuTrigger);
      const backButtons = panel.querySelectorAll(selectors.submenuBack);

      triggers.forEach(trigger => {
        trigger.addEventListener('click', (event) => {
          if (trigger.parentElement.querySelector(selectors.submenuPanel)) {
            event.preventDefault();
            const subPanel = trigger.parentElement.querySelector(selectors.submenuPanel);
            if (subPanel) {
              subPanel.classList.add(classes.submenuOpen);
            }
          }
        });
      });

      backButtons.forEach(button => {
        button.addEventListener('click', () => {
          const parentPanel = button.closest(selectors.submenuPanel);
          if (parentPanel) {
            parentPanel.classList.remove(classes.submenuOpen);
          }
        });
      });
    }
  }

  // --- Shopify Theme Editor Integration ---
  function loadHeader(event) {
    const container = event.target;
    new CustomHeader(container);
  }

  document.addEventListener('DOMContentLoaded', () => {
    new CustomHeader(document);
  });
  if (Shopify.designMode) {
    document.addEventListener('shopify:section:load', loadHeader);
    document.addEventListener('shopify:section:reorder', () => new CustomHeader(document));
  }
})();


document.addEventListener('DOMContentLoaded', function () {
  // Wait for Shopify's predictive search to be initialized
  document.addEventListener('predictive-search-open', function () {
    const psComponent = document.querySelector('predictive-search');
    if (!psComponent) return;

    // Override the close() method to prevent auto-hiding when results exist
    const originalClose = psComponent.close.bind(psComponent);
    psComponent.close = function () {
      const resultsDiv = document.getElementById('predictive-search-results');
      const hasResults = resultsDiv && (
        resultsDiv.querySelector('.custom-ps-product-item') || 
        resultsDiv.querySelector('.custom-ps-item')
      );

      // Only allow close if really no results
      if (!hasResults) {
        originalClose();
      }
      // Otherwise: do nothing → dropdown stays open!
    };
  });
});